<template>
  <div class="jwl-roles-table">
    <h1 class="text-4xl">
      {{ $t('common.profile.yourAssignedRoles') }}
    </h1>

    <table class="jwl-roles-table__table">
      <thead>
      <tr>
        <th colspan="2">
          {{ $t('common.profile.selectYourAssignedRoles') }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="userRole in rolesList" :key="`student-row-${userRole}`" class="jwl-roles-table__student-row">
        <td>
          {{ $t(`common.roles.${userRole}`) }}
        </td>
        <td>
          <button ref="roleButton" class="jwl-roles-table__select" role="button" @click="selectRole(userRole)">
            <jwl-icon
              v-if="isSelected(userRole)"
              class="jwl-roles-table__select-selected"
              icon-name="check"
              icon-style="regular"/>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup>
  const emits = defineEmits(['rolesError', 'updated']);
  const moduleStore = useModuleStore();
  const rolesList = ref([]);
  const selectedRoles = ref([]);
  const { currentUser } = moduleStore;

  const roleButton = ref();

  const getRolesList = () => {
    moduleStore.getData('profile/userApplicationRoles').then((data) => {
      rolesList.value = data.possibleApplicationRoles;
    }).catch((e) => {
      emits('rolesError', e);
    });
  };

  const updateCurrentRoles = () => {
    const formData = new FormData();
    formData.set('roles', JSON.stringify(selectedRoles.value));
    moduleStore.postData({ url: 'profile/rights-for-selected-roles', formData }).then(() => {
      moduleStore.getBaseData(moduleStore.mode === 'lms');
      emits('updated');
    }).catch((e) => {
      emits('rolesError', e);
    });
  };

  const isSelected = (role) => selectedRoles.value.includes(role);

  const selectRole = (role) => {
    if (!selectedRoles.value.includes(role)) {
      selectedRoles.value = [role];
      updateCurrentRoles();
    }
  };

  onMounted(() => {
    selectedRoles.value = currentUser.applicationRoles;
    getRolesList();
  });

  defineExpose({
    roleButton,
  });
</script>

<style lang="scss">
  .jwl-roles-table {
    &__table {
      text-align: left;

      th {
        padding-right: 1rem;
      }

      td {
        padding-right: 1rem;
      }
    }

    &__select {
      align-items: center;
      background-color: transparent;
      border: .1rem solid var(--color-gray-500);
      border-radius: var(--border-radius);
      color: transparent;
      cursor: pointer;
      display: grid;
      grid-template: "content" 100% / 100%;
      height: 1.33rem;
      justify-content: center;
      margin: 0 auto;
      transition: color .25s;
      width: 1.65rem;

      &-selected {
        color: var(--color-grey);
      }

      &-deselected {
        color: var(--color-grey);
      }
    }
  }
</style>
